import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=0f171fff&scoped=true&"
import script from "./activity-list.vue?vue&type=script&lang=js&"
export * from "./activity-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=0f171fff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f171fff",
  null
  
)

component.options.__file = "activity-list.vue"
export default component.exports